<template>
  <div class="ViewSentEmailFilterBar">
    <div class="container-fluid">
       <!-- <div class="text-center margin-bottom-7Perc">
          <h3 class="col-xs-12 col-sm-12 col-md-12 col-lg-12">Sent Emails</h3>
       </div> -->
       <div class="row margin-top-3Perc margin-left-0Perc vertical-align">
           <div class="col-md-1 col-lg-1"></div>
           <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-align-right padding-right-0Perc">
              Group Course
           </div>
           <div class=" col-md-3 col-lg-3 padding-left-1Perc">
            <div class="form-group">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-0px padding-right-0Perc">
               <select class="form-control" v-model="selectedGroupObj">
                <option value=-1 disabled>Select</option>
                <option v-for="groupCourseObj in getGroupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
               </select>
              </div>
            </div>
           </div>
           <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 text-align-right padding-right-0Perc">
              Cohort  
           </div>
           <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 padding-left-1Perc">
             <div class="form-group">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-0px padding-right-0Perc">
                <select class="form-control" v-model="selectedCohortObj">
                 <option value='-1' disabled>Select</option>
                 <option v-for="cohortObj in getAssociatedCohorts" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
                </select> 
              </div>
             </div>   
           </div>
           <div class="col-md-2 col-lg-2"></div> 
       </div>
       <div class="row margin-top-3Perc margin-left-0Perc vertical-align">
         <div class="col-md-1 col-lg-2"></div>
         <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 text-align-right padding-right-0Perc">
          From
         </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
          <div class="form-group">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-0px padding-right-0Perc">
                <select class="form-control" v-model="selectedEmailObj">
                <option value='-1' disabled>Select e-mail address</option>
                <option value=''>All</option>
                <option v-for="emailObj in getEmailList" v-bind:key="emailObj" v-bind:value="emailObj">{{ emailObj }}</option>
              </select> 
            </div>
          </div>       
        </div>
         <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 text-align-right padding-right-0Perc">
          Template  
         </div>
         <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
           <div class="form-group">
             <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-0px padding-right-0Perc">
               <select class="form-control" v-model="selectedTemplateObj">
                 <option value='-1' disabled>Select</option>
                 <option value=''>All</option>
                 <option v-for="templateObj in getTemplateList" v-bind:key="templateObj.EmailTemplateId" v-bind:value="templateObj">{{ templateObj.EmailTemplateName }}</option>
               </select> 
            </div>
           </div>   
         </div>
         <div class="col-md-2 col-lg-2"></div>
      </div>
      
      <div class="row margin-top-3Perc">
        <div class="col-lg-4"></div>
        <div class="col-lg-4">
          <button type="button" class="btn btn-default button-orange col-lg-offset-4 col-lg-4" @click="checkAndEmit($event)">View</button>
        </div>
        <div class="col-lg-4"></div>
      </div>
     </div>
     <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div> 
      <loader></loader>     
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import { groupCourseService } from '@/server-util/group-course-service'
import { emailService } from '@/server-util/email-service'
import { cohortService } from '@/server-util/cohort-service'
import AlertBox from '@/components/AlertOverlay'
export default {
  created: function () {
    this.getAllGroupCourses()
    this.getSenderEmailIdList()
    this.getAllTemplateList()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedGroupObj: -1,
      selectedCohortObj: -1,
      selectedEmailObj: -1,
      selectedTemplateObj: -1,
      associatedCohortList: []
    }
  },
  methods: {
    checkAndEmit: function (event) {
      if (this.selectedGroupObj !== -1) {
        if (this.selectedCohortObj !== -1) {
          if (this.selectedEmailObj !== -1) {
            if (this.selectedTemplateObj !== -1) {
              // AK: Emit selected Group Course, cohort, email , Template obj
              var obj = {
                selectedGroupObj: this.selectedGroupObj,
                selectedCohortObj: this.selectedCohortObj,
                selectedEmailObj: this.selectedEmailObj,
                selectedTemplateObj: this.selectedTemplateObj
              }
              this.$emit('selectedFilterObj', obj)
            } else {
              this.showAlertDialog = true
              this.errorMsg =
                'Please select a template.'
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg =
              'Please select an e-mail address.'
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg =
            'Please select a cohort.'
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select a group course.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedGroupObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Cohort list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedGroupObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupObj.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in \'' + this.selectedGroupObj.GroupName + ' :: ' + this.selectedGroupObj.CourseTitle + subTitleName + '\'.'
              }
              this.associatedCohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated Cohort(s) OPERATION'
        )
      }
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    },
    getSenderEmailIdList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        emailService
          .getSenderEmailList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.senderEmailList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined SENDER EMAIL ID LISTING OPERATION'
        )
      }
    },
    getAllTemplateList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        emailService
          .getTemplateList(
            storeObj.state.access_token, constants.EmailTemplateType.Normal
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.templateList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined ALL TEMPLATE LISTING OPERATION'
        )
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getGroupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    getSelectedCohortObj: {
      get: function () {
        return this.selectedCohortObj
      }
    },
    getShowExportState: {
      get: function () {
        return this.showExport
      }
    },
    getEmailList: {
      get: function () {
        return this.$store.state.senderEmailList
      }
    },
    getTemplateList: {
      get: function () {
        return this.$store.state.templateList
      }
    }
  },
  watch: {
    selectedGroupObj: function () {
      // AK: Reset Selected Cohort Obj to -1 again
      this.selectedCohortObj = -1
      this.getAssociatedCohortList()
    }
  },
  name: 'ViewSentEmailFilterBar'
}
</script>

<style scoped>
.ViewSentEmailFilterBar {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-green {
  border: 1px solid green;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.text-align-left {
  text-align: left !important;
}
.padding-left-0px {
  padding-left: 0px !important;
}
.font-size-18px {
  font-size: 18px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.background-gray {
  background-color: #ddd;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.right-border-color {
  /*border-right: 1px solid #43495e;*/
}
.vertical-align {
  display: flex;
  align-items: center;
}
.width-1Perc {
  width: 1% !important;
}
.cursor-pointer {
  cursor: pointer;
}
.width-9-Perc {
  width: 9% !important;
}
@media (max-width: 1024px) {
  .width-9-Perc {
    width: 11.5% !important;
  }
}
.font-weight-bold {
  font-weight: bold;
}
.font-size-15px {
  font-size: 15px;
}
.alignCenter{
  align: center;
}
.margin-0-auto{
  margin: 0 auto !important;
}
.border-color-yellow{
  border:1px solid yellow;
}
.align-center{
  align:center !important;
}
.margin-left-0Perc{
  margin-left:0% !important;
}
.margin-left-1Perc{
  margin-left:1% !important;
}
.margin-left-3Perc{
  margin-left:3% !important;
}
.demo-margin-left-1Perc{
  margin-left:1% !important;
}
.border-grey{
  border:1px solid grey;
}
.padding-left-1Perc{
  padding-left:1% !important;
}
.padding-right-0Perc{
  padding-right:0% !important;
}
.padding-left-6Perc{
  padding-left:6%;
}
.padding-left-12Perc{
  padding-left:12%;
}

.margin-bottom-7Perc{
  margin-bottom: 7%;
}
.padding-15px{
  padding:15px;
}
.border-1px{
  border: 1px solid #ccc;
}
.font-size-18px{
    font-size: 18px;
}
.margin-right-4Perc{
  margin-right:4%;
}
.margin-right-1Perc{
  margin-right:1%;
}
.text-align-right {
 text-align: right !important;
}
.vertical-align {
 display: flex;
 align-items: center;
}
.button-orange{
    background-color: #f39c12 !important;
    border: 1px solid #f39c12 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/emails/view_sent_emails/ViewSentEmailsFilterBar.vue